import { Map } from '../../../../@inax/common';

/**
 * Interface for the transport, this is used to send the plcWrite request to INAX.
 * @class IPlcWriteTransportPack
 * @author insite-gmbh
 */
export interface IPlcWriteTransportPack {
    /**
     * This is the target mapping
     *
     * @propertyToto
     * @type {Array<PlcSubscriber>}
     */
    To: string;

    /**
     * This is the write KeyValuePair
     *
     * @property Set
     * @type {Map<any>}
     */
    Set: Map<any>;

    /**
     * This is the mapping which will be used by the wehre clause.
     *
     * @property From
     * @type {string}
     * @default null
     */
    From: string;

    /**
     * This is to specify the a where clause for the write operation.
     *
     * @property Where
     * @type {string}
     * @default null
     */
    Where: string;

    /**
     * This is to specify if the vardeclaration is a symbol or a address.
     *
     * @property Abs
     * @type {string}
     * @default null
     */
    Abs: boolean;
}


/**
 * Implementation for the transport interface. This is used to send the plcWrite request to INAX.
 * @class PlcWriteTransportPack
 * @author insite-gmbh
 */
export class PlcWriteTransportPack implements IPlcWriteTransportPack {
        /**
     * This is the target mapping
     *
     * @propertyToto
     * @type {Array<PlcSubscriber>}
     */
    To: string;

    /**
     * This is the write KeyValuePair
     *
     * @property Set
     * @type {Map<any>}
     */
    Set: Map<any>;

    /**
     * This is the mapping which will be used by the wehre clause.
     *
     * @property From
     * @type {string}
     * @default null
     */
    From: string;

    /**
     * This is to specify the a where clause for the write operation.
     *
     * @property Where
     * @type {string}
     * @default null
     */
    Where: string;

    /**
     * This is to specify if the vardeclaration is a symbol or a address.
     *
     * @property Abs
     * @type {string}
     * @default null
     */
    Abs: boolean;
}

